// extracted by mini-css-extract-plugin
export var wordContainer = "_oq-0";